import { createIcon } from './icon';

export const GiftCardIcon = createIcon(
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3.33333H13.1833C13.275 3.075 13.3333 2.79167 13.3333 2.5C13.3333 1.11667 12.2167 0 10.8333 0C9.95833 0 9.2 0.45 8.75 1.125L8.33333 1.68333L7.91667 1.11667C7.46667 0.45 6.70833 0 5.83333 0C4.45 0 3.33333 1.11667 3.33333 2.5C3.33333 2.79167 3.39167 3.075 3.48333 3.33333H1.66667C0.741667 3.33333 0.00833333 4.075 0.00833333 5L0 14.1667C0 15.0917 0.741667 15.8333 1.66667 15.8333H15C15.925 15.8333 16.6667 15.0917 16.6667 14.1667V5C16.6667 4.075 15.925 3.33333 15 3.33333ZM10.8333 1.66667C11.2917 1.66667 11.6667 2.04167 11.6667 2.5C11.6667 2.95833 11.2917 3.33333 10.8333 3.33333C10.375 3.33333 10 2.95833 10 2.5C10 2.04167 10.375 1.66667 10.8333 1.66667ZM5.83333 1.66667C6.29167 1.66667 6.66667 2.04167 6.66667 2.5C6.66667 2.95833 6.29167 3.33333 5.83333 3.33333C5.375 3.33333 5 2.95833 5 2.5C5 2.04167 5.375 1.66667 5.83333 1.66667ZM15 14.1667H1.66667V12.5H15V14.1667ZM15 10H1.66667V5H5.9L4.16667 7.35833L5.51667 8.33333L8.33333 4.5L11.15 8.33333L12.5 7.35833L10.7667 5H15V10Z"
      fill="currentColor"
    />
  </svg>,
  'GiftCardIcon'
);
